import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const TableEditSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default TableEditSVG;
